import React, { Component } from 'react';
import { Form, Input , Button, Grid,  Segment, Message , Radio , Checkbox , Select , TextArea , Dropdown } from 'semantic-ui-react';
import RadioInputDoble , { DatePicketControl } from '../controls/Controles'; 

 const Alternativa = ( {props , name , changeHandler , item } ) => {
    return(
      <RowAlternativa
        item={props.item}
        
        />
    );
  }

 export default class RowAlternativa extends Component {
  
    constructor(props) {
        super(props);
        this.state = {
          isLoaded: false,
          errors: [],
          error: null,
          alternativa : props.item,
          options : props.options 
        };

    }

    componentDidMount() {
    }

    render() {
        //let METHODNAME = 'render - ';
        if(  this.state.alternativa != null ){
            this.state.isLoaded = true; 
        }

        const { error, isLoaded , alternativa , options } = this.state;

        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {
            
            let tipoControl = alternativa.tipoControl.tipoControlId;
            //console.log(METHODNAME + 'pintar por control');
            
            if( tipoControl === 1){
                return(
                    <Grid.Row columns={1} key={alternativa.alternativaId}>
                        <Radio
                            key={alternativa.alternativaId}
                            id={alternativa.name+'_'+alternativa.alternativaId}
                            label={alternativa.label}
                            name={alternativa.name}
                            value={alternativa.value}
                            disabled={alternativa.disabled}
                            checked={alternativa.checked}
                            onChange = {( name , value ) => this.props.onChangeRadio(name , value)}
                        />
                    </Grid.Row>
                );
            } else if( tipoControl === 2){
                return(
                    <h2>Alternativa - tipo control 2 CheckBox </h2>
                );
            }else if( tipoControl === 3){
                return(
                    
                    <Grid.Row columns={1} key={alternativa.alternativaId}>
                        <Grid.Column>
                            <Segment> 
                            <Form.Field key={alternativa.alternativaId} inline>
                                <label>{alternativa.label}</label>
                                <DatePicketControl
                                    id={alternativa.alternativaId}
                                    name={alternativa.name}
                                    changeHandler = {( date , name ) => this.props.onChange(  date , name  )}
                                    valor={new Date(alternativa.value)}
                                />
                            </Form.Field>
                            </Segment>
                        </Grid.Column> 
                    </Grid.Row>
                    
                );
            }else if( tipoControl === 4){
                return(
                    <h2>Alterativa - tipo control 4 </h2>
                );
            }else if( tipoControl === 5){
                return( 
                    <Grid.Row columns={1} key={alternativa.alternativaId} >
                        <Grid.Column>
                            <Segment>
                                <Form.Field key={alternativa.alternativaId} inline>
                                    <label>{ alternativa.label }
                                        <span style={ {'color' : 'white' } }>( { alternativa.tipoControl.nombre})</span>
                                    </label>
                                    <TextArea 
                                        placeholder={alternativa.label}
                                        id={alternativa.alternativaId}
                                        name={alternativa.name}
                                        value={alternativa.value}
                                        onChange = {(e) => this.props.onChangeText(e)}  
                                        />
                                </Form.Field> 
                            </Segment>
                        </Grid.Column> 
                    </Grid.Row>
                    
                );
            }else if( tipoControl === 6){
                return(
                    <Grid.Row columns={1} key={alternativa.alternativaId} >
                        <Grid.Column>
                            <Segment> 
                                <Form.Field key={alternativa.alternativaId} inline>
                                    <label>{alternativa.label}</label>
                                    <Dropdown 
                                        floating 
                                        selection 
                                        fluid
                                        selectOnBlur={false}
                                        id={'select_'+alternativa.alternativaId}
                                        name={'select_'+alternativa.alternativaId}
                                        placeholder='-SELECCIONAR-'
                                        onChange={( event , data ) => this.props.onChangeSelect( event , data )} 
                                        value={alternativa.value}
                                        options={options}
                                    />
                                </Form.Field>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                );
            }else if( tipoControl === 7){
                //Input Numeric 
                return( 
                    <Grid.Row columns={1} key={alternativa.alternativaId} >
                        <Grid.Column>
                            <Segment>
                                <Form.Field key={alternativa.alternativaId} inline>
                                    <label>{ alternativa.label }
                                        <span style={ {'color' : 'white' } }>( { alternativa.tipoControl.nombre})</span>
                                    </label>
                                    <Input 
                                        placeholder={alternativa.label}
                                        id={alternativa.alternativaId}
                                        name={alternativa.name}
                                        value={alternativa.value}
                                        onChange = {(e) => this.props.onChangeText(e)} 
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                              event.preventDefault();
                                            }
                                          }}
                                        />
                                </Form.Field> 
                            </Segment>
                        </Grid.Column> 
                    </Grid.Row>
                    
                );
            }else if( tipoControl === 8){
                return ( "" );

            }else if( tipoControl === 9){
                return ( 

                    <RadioInputDoble
                        id={alternativa.name+'_'+alternativa.alternativaId}
                        label={alternativa.label}
                        name={alternativa.name}
                        value={alternativa.value}
                        isChecked={alternativa.checked}
                        handleChange={(e) => this.props.handleChange(e)}
                        isChecked2={alternativa.checked2}
                        handleChange2={(e) => this.props.handleChange2(e)}
                    />

                 );
            }else if( tipoControl === 10){

                    let words = alternativa.label.split('|');

                    return (
                        <div className="ui horizontal segments" style={ {width: '100%' } }>                            
                            <div className="ui segment" style={ {width: '40%' } }>
                                <label>
                                    <span>{words[0]}</span>
                                </label>
                            </div> 
                            <div className="ui segment" style={ {width: '20%' } }>
                                <label></label>
                            </div> 
                            <div className="ui segment" style={ {width: '40%' , textAlign : 'right'} }>
                                <label >
                                    <span>{words[1]}</span>
                                </label>
                            </div>
                        </div>
                     );
            
            } else if( tipoControl === 11){
               
                return(
                    <Grid.Row columns={1} key={alternativa.alternativaId}>
                        <Radio toggle 
                            key={alternativa.alternativaId}
                            id={alternativa.name+'_'+alternativa.alternativaId}
                            label={alternativa.label}
                            name={alternativa.name}
                            value={alternativa.value}
                            disabled={alternativa.disabled}
                            checked={alternativa.checked}
                            onChange = {( name , value ) => this.props.onChangeRadio(name , value)}   
                        />
                    </Grid.Row>
                );
            } else {
                return ( <h2>no implementado</h2>);
            }
            
        }
    }

}